import $ from '../tools/Dom';
import Viewport from '../tools/Viewport';
import * as Events from '../lib/events';
import { loadFlickity } from '../lib/async-bundles';

export default (el, data) => {
    const dom = $(el);
    const slides = dom.find('[data-slide]');
    const slideCount = slides.length;
    let currentBreakpoint = Viewport.breakpoint.size;
    let flkty;
    let Flickity;
    let hasSlider = false;

    const startFlickity = () => {
        console.log('startFlickity');
        hasSlider = true;
        flkty = new Flickity(el, {
            cellSelector: '[data-slide]',
            wrapAround: true,
            contain: true,
            pageDots: false,
            prevNextButtons: true,
            draggable: true,
            dragThreshold: 10,
            cellAlign: 'left',
            setGallerySize: true,
            percentPosition: true,
            accessibility: false,
            arrowShape: 'M65.9 100c-2.2 0-4.3-1-5.7-2.9L27.3 50 60.2 2.9c2.2-3.1 6.5-3.9 9.6-1.7 3.1 2.2 3.9 6.5 1.7 9.6L44.1 49.9 71.5 89c2.2 3.1 1.4 7.4-1.7 9.6-1.2 1-2.6 1.4-3.9 1.4z'
        });

        // slides.on('focus', e => {
        //     flkty.select(slides.index(e.triggerTarget));
        // });
    };

    const killFlickity = () => {
        console.log('killFlickity');
        hasSlider = false;
        flkty.destroy();
    }

    const shouldHaveSlider = () => {
        if (currentBreakpoint >= data.l) {
            return slideCount > 3;
        } else if (currentBreakpoint >= data.m) {
            return slideCount > 2;
        }

        return slideCount > 1;
    };

    const onBreakpoint = e => {
        currentBreakpoint = e.detail.current.size;

        if (shouldHaveSlider() && !hasSlider) {
            startFlickity();
        } else if (!shouldHaveSlider() && hasSlider) {
            killFlickity();
        }
    };

    const init = () => {
        Viewport.on('breakpoint', onBreakpoint);

        if (dom.find('img').length === 0) {
            dom.addClass('js-no-images');
        }

        loadFlickity(flickity => {
            Flickity = flickity;
            if (shouldHaveSlider() && !hasSlider) {
                startFlickity();
            }
        });
    };

    const destroy = () => {
        Viewport.off('breakpoint', onBreakpoint);
        if (hasSlider) {
            killFlickity();
        }
    };

    return {
        init,
        destroy
    };
};
